import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import { ShieldCheck, Thermometer, Award, MapPin } from 'lucide-react'
import { Section } from '../ui/Section'
import { Container } from '../ui/Container'
import { SectionTitle } from '../ui/SectionTitle'

const strengths = [
  { key: 'reliability', icon: ShieldCheck },
  { key: 'temperature', icon: Thermometer },
  { key: 'certifications', icon: Award },
  { key: 'coverage', icon: MapPin },
] as const

export function StrengthPoints() {
  const { t } = useTranslation('common')

  return (
    <Section variant="light">
      <Container>
        <SectionTitle
          title={t('home.strengths.title')}
          subtitle={t('home.strengths.subtitle')}
          centered
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {strengths.map((strength, index) => (
            <motion.div
              key={strength.key}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="text-center p-6"
            >
              <div className="w-16 h-16 mx-auto mb-4 bg-brand-red/10 rounded-full flex items-center justify-center">
                <strength.icon className="w-8 h-8 text-brand-red" />
              </div>
              <h3 className="text-xl font-semibold text-brand-dark mb-2">
                {t(`home.strengths.${strength.key}.title`)}
              </h3>
              <p className="text-brand-text leading-relaxed">
                {t(`home.strengths.${strength.key}.description`)}
              </p>
            </motion.div>
          ))}
        </div>
      </Container>
    </Section>
  )
}
